import React, { createContext, useContext, useEffect, useState } from 'react';

import { useCurrentUser } from './CurrentUserContext';

interface AgreementContextType {
  hasExpiredAgreements: boolean;
}

const AgreementContext = createContext<AgreementContextType | undefined>(undefined);

export const useAgreement = () => {
  const context = useContext(AgreementContext);
  if (context === undefined) {
    throw new Error('useAgreement must be used within an AgreementProvider');
  }
  return context;
};

export const AgreementProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [hasExpiredAgreements, setHasExpiredAgreements] = useState(false);
  const {
    state: { account, isInitialized },
  } = useCurrentUser();

  useEffect(() => {
    if (isInitialized && account) {
      setHasExpiredAgreements(account.pendingTermsAndConditions);
    }
  }, [isInitialized, account]);

  return <AgreementContext.Provider value={{ hasExpiredAgreements }}>{children}</AgreementContext.Provider>;
};
